import { useState, useCallback } from 'react';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import RecipientTag from './RecipientTag';
import { useEmailRecipientOptions } from '../../../hooks/useEmailRecipientOptions';
import { createNewEmailOption } from '../../../utils/emails';

// Adapted from https://git.hubteam.com/HubSpotProtected/settings-ui-payments/blob/master/settings-ui-payments/static/js/components/EmailRecipientSearchInput.js
import { jsx as _jsx } from "react/jsx-runtime";
const EmailRecipientSearchInput = ({
  selectedOptions,
  onSelectedOptionChange
}) => {
  const [searchTextQuery, setSearchTextQuery] = useState('');
  const internalValue = selectedOptions.map(email => email.address);
  const emailRecipientOptions = useEmailRecipientOptions(searchTextQuery);
  const getOptions = useCallback(() => {
    if (emailRecipientOptions.length) {
      return selectedOptions.concat(emailRecipientOptions);
    } else if (searchTextQuery.trim()) {
      return selectedOptions.concat(createNewEmailOption(searchTextQuery));
    }
    const dummyOption = {
      text: I18n.text('cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.typeToSearch'),
      disabled: true
    };
    return selectedOptions.concat(dummyOption);
  }, [emailRecipientOptions, searchTextQuery, selectedOptions]);
  return /*#__PURE__*/_jsx(FormControl, {
    label: I18n.text('cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.emailAddress'),
    children: /*#__PURE__*/_jsx(UISelect, {
      valueComponent: RecipientTag,
      autoload: false,
      cache: false,
      multi: true,
      onInputChange: setSearchTextQuery,
      onSelectedOptionChange: onSelectedOptionChange,
      options: getOptions(),
      placeholder: I18n.text('cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.recipientPlaceholder'),
      value: internalValue
    })
  });
};
export default EmailRecipientSearchInput;